export default "__VITE_ASSET__46fc4fdd__"